import React from 'react';
import ConditionalLink from '@plone/volto/components/manage/ConditionalLink/ConditionalLink';
import MoreLink from './MoreLink';
import { dateRange, longDate, publishedDate } from './meetDates';

// Titles with their dates, between rules: results and rankings lists
const RuledListTemplate = ({ items, linkTitle, linkHref, isEditMode }) => (
  <>
    <ul className="asaj-list">
      {items.map((item) => {
        // Meets show their own dates; everything else its publication date
        const meet = item.start ? dateRange(item.start, item.end) : null;
        const date = item.start || publishedDate(item);
        return (
          <li key={item['@id']}>
            <ConditionalLink item={item} condition={!isEditMode}>
              <span>{item.title}</span>
              {date && (
                <time dateTime={date}>
                  {meet ? `${meet.range} ${meet.year}` : longDate(date)}
                </time>
              )}
            </ConditionalLink>
          </li>
        );
      })}
    </ul>
    <MoreLink
      linkTitle={linkTitle}
      linkHref={linkHref}
      isEditMode={isEditMode}
    />
  </>
);

export default RuledListTemplate;
